<label class="form-label">{{ field.name | translateField: { obj: field, property: 'name' } }}</label>
<div [ngClass]="{ 'input-group': lang && (field.fieldType.name === 'string' || field.fieldType.name === 'free-text') }" class="input-group">
  <div class="input-group-prepend" *ngIf="lang && (field.fieldType.name === 'string' || field.fieldType.name === 'free-text') ">
      <span class="input-group-text"><i class="flag-icon flag-icon-{{lang ?? 'es'}}"></i> </span>
  </div>
  <input
    type="text"
    #inputRef="ngModel"
    [class.error]="(!value || value == '') && form.submitted && field.required && !readOnlyStatus"
    class="form-control"
    *ngIf="field.fieldType.name === 'string'"
    [(ngModel)]="value"
    placeholder="{{'COMMON.PLACEHOLDER.INPUT' | translate}} {{ field.name | translateField: { obj: field, property: 'name' } }}"
    [readonly]="readOnlyStatus" (change)="onChange($event)"
  />
  <input
    type="number"
    #inputRef="ngModel"
    [class.error]="(!value || value == '') && form.submitted && field.required && !readOnlyStatus"
    class="form-control"
    *ngIf="field.fieldType.name === 'number'"
    [(ngModel)]="value"
    placeholder="{{'COMMON.PLACEHOLDER.INPUT' | translate}} {{ field.name | translateField: { obj: field, property: 'name' } }}"
    [readonly]="readOnlyStatus" (change)="onChange($event)"
  />
  <textarea
    type="number"
    #inputRef="ngModel"
    [class.error]="(!value || value == '') && form.submitted && field.required && !readOnlyStatus"
    class="form-control"
    *ngIf="field.fieldType.name === 'free-text'"
    [(ngModel)]="value"
    placeholder="{{'COMMON.PLACEHOLDER.INPUT' | translate}} {{ field.name | translateField: { obj: field, property: 'name' } }}"
    [readonly]="readOnlyStatus" (change)="onChange($event)"
  ></textarea>
</div>

<span *ngIf="!value && form.submitted && field.required && !readOnlyStatus" class="invalid-form">
  <small class="form-text text-danger" *ngIf="(!value || value == '') && !readOnlyStatus">    
    {{ field.name | translateField: { obj: field, property: 'name' } }} {{'COMMON.VALIDATIONS.REQUIRED' | translate}}
  </small>
</span>
